import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';

import App from '@/components/App';
import { EditPhotoPane } from '@/components/EditPhotoPane';
import { MapPane } from '@/components/MapPane';
import { PhotoGridPane } from '@/components/PhotoGridPane';
import { PhotoPane } from '@/components/PhotoPane';
import { TimelinePane } from '@/components/TimelinePane';
import { UploadPhotoPane } from '@/components/UploadPhotoPane';
import { UserListPane } from '@/components/UserListPane';
import { UserPane } from '@/components/UserPane';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ErrorToast } from '@/components/ErrorToast';
import { AuthStateProvider } from '@/hooks/AuthStateContext';
import { ErrorProvider } from '@/hooks/ErrorContext';
import { MarkerProvider } from '@/hooks/MarkerContext';
import { PhotoStateProvider } from '@/hooks/PhotoStateContext';
import { UserStateProvider } from '@/hooks/UserStateContext';
import DebugPage from '@/pages/DebugPage';
import LoginPage from '@/pages/LoginPage';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorProvider>
      <ErrorBoundary>
        <AuthStateProvider>
          <UserStateProvider>
            <PhotoStateProvider>
              <MarkerProvider>
                <BrowserRouter>
                  <ErrorBoundary>
                    <Routes>
                      <Route path="/" element={<App />}>
                        <Route path="photos/:photoId/map" element={<MapPane />} />
                        <Route path="photos/:photoId" element={<PhotoPane />} />
                        <Route path="photos/:photoId/edit" element={<EditPhotoPane />} />
                        <Route path="photos" element={<PhotoGridPane />} />
                        <Route path="photos/map" element={<MapPane />} />
                        <Route path="photos/calendar" element={<PhotoGridPane mode="calendar" />} />
                        <Route path="photos/timeline" element={<TimelinePane />} />
                        <Route path="photos/upload" element={<UploadPhotoPane />} />
                        <Route path="photos/filter" element={<PhotoGridPane mode="filter" />} />
                        <Route path="users" element={<UserListPane />} />
                        <Route path="user/:userId" element={<UserPane />} />
                      </Route>
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/debug" element={<DebugPage />} />
                    </Routes>
                  </ErrorBoundary>
                </BrowserRouter>
                <ErrorToast />
              </MarkerProvider>
            </PhotoStateProvider>
          </UserStateProvider>
        </AuthStateProvider>
      </ErrorBoundary>
    </ErrorProvider>
  </StrictMode>,
)
